import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import Money from '@/components/Money.vue'
import Tooltip from '@/components/Tooltip.vue'
import Days from '@/components/Days.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'DaysWithMissedIncome',
  props: {
    missedIncome: null,
    days: null
  },
  setup(__props: any) {

const props = __props as {
    missedIncome: number | null
    days: number
};



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("td", null, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style.container)
    }, [
      _createElementVNode("span", null, [
        _createVNode(Days, {
          value: __props.days || 0
        }, null, 8, ["value"])
      ]),
      _createVNode(Tooltip, { tooltip: "Missed income per day" }, {
        default: _withCtx(() => [
          _createVNode(Money, {
            "hide-zero": "",
            value: __props.missedIncome
          }, null, 8, ["value"])
        ]),
        _: 1
      })
    ], 2)
  ]))
}
}

})